import styles from './index.module.scss';

function Ruler(props) {
  return (
    <div className={[styles.ruler, props.className].join('\x20')}>
      <div className={styles.rulerMain}>
        <ul className={styles.rule}>
          <li>1. 活动时间：即日起至8月31日23:59:59</li>
          <li>2. 本活动仅限平安官网登录用户参与</li>
          <li>3. 活动期间，每位用户可参与一次抽奖，我们将于活动结束后3个工作日内联系中奖用户注册手机号安排奖品发放事宜，请及时查看。我们会在60个工作日内发放奖品。</li>
          <li>4. 奖品图片仅为参考，实际以实物为准。</li>
          <li>5. 为保证活动期间公平公正，严禁违规刷奖，非官方途径参与活动等破坏活动公平性行为，违者取消活动资格；</li>
          <li>6. 奖品兑换及其他活动相关问题请微信搜索并关注【平安微官方】公众号（weipingan95511），后台联系客服咨询</li>
          <li className={styles.interpretation}>本活动最终解释权归平安科技所有。</li>
        </ul>
        <div onClick={() => props.onClick()} className={styles.iKnow}></div>
      </div>
    </div>
  )
}

export default Ruler;
